import React from "react";

import Grid from "@material-ui/core/Grid";

import FormHelperText from "@material-ui/core/FormHelperText";

import {renderQuestion} from "../../../../../../utils";

const WaysOfDistributionStep = (props) => {
  const {
    onAnswerChange,
    dataService,
    questions: [
      waysOfDistribution
    ],
  } = props;

  const handleAnswerChange = (uid, value) => {
    waysOfDistribution.error = null; // clean error
    onAnswerChange(uid, value);
  };

  return (
    <>
      {waysOfDistribution.error && (
        <Grid item xs={12} style={{justifySelf: 'center'}}>
          <FormHelperText error>{waysOfDistribution.error}</FormHelperText>
        </Grid>
      )}
      {renderQuestion(waysOfDistribution, handleAnswerChange, dataService)}
      <Grid item xs={12} style={{fontSize: 16, textAlign: 'center'}}>
        Zusätzlich zu den gewählten Zustelloptionen werden alle Dokumente in das Online-Postfach eingestellt.
      </Grid>
    </>
  )
};

export default WaysOfDistributionStep;